// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import RelatedPartiesActionTypes from './related-parties.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	addBusinessPartiesResponse: null,
	updateBusinessPartiesResponse: null,
	fetchBusinessPartiesResponse: null,
	fetchBusinessPartiesList: [],
	deleteBusinessPartiesResponse: null,
};

// BUSINESS RELATED PARTIES REDUCER - START
const businessRelatedPartiesReducer: any = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD BUSINESS REALETED PARTIES START *********************** */
		case RelatedPartiesActionTypes.ADD_RELATED_PARTIES_SUCCESS:
			return { ...state, addBusinessPartiesResponse: action.payload };

		case RelatedPartiesActionTypes.ADD_RELATED_PARTIES_FAILURE:
			return { ...state, addBusinessPartiesResponse: action.payload };

		case RelatedPartiesActionTypes.ADD_RELATED_PARTIES_RESPONSE_CHANGED:
			return { ...state, addBusinessPartiesResponse: null };
		/** ***************** ADD BUSINESS REALETED PARTIES END *********************** */

		/** ***************** UPDATE BUSINESS REALETED PARTIES START *********************** */
		case RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_SUCCESS:
			return { ...state, updateBusinessPartiesResponse: action.payload };

		case RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_FAILURE:
			return { ...state, updateBusinessPartiesResponse: action.payload };

		case RelatedPartiesActionTypes.UPDATE_RELATED_PARTIES_RESPONSE_CHANGED:
			return { ...state, updateBusinessPartiesResponse: null };
		/** ***************** UPDATE BUSINESS REALETED PARTIES END *********************** */

		/** ***************** FETCH BUSINESS REALETED PARTIES START *********************** */
		case RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_SUCCESS:
			return {
				...state,
				fetchBusinessPartiesResponse: action.payload,
				fetchBusinessPartiesList: docodeHexResponse(
					action.payload,
					'GetBusinessReletedPartiesKey',
				),
			};

		case RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_FAILURE:
			return { ...state, fetchBusinessPartiesResponse: action.payload };

		case RelatedPartiesActionTypes.FETCH_RELATED_PARTIES_RESPONSE_CHANGED:
			return { ...state, fetchBusinessPartiesResponse: null, fetchBusinessPartiesList: [] };
		/** ***************** FETCH BUSINESS REALETED PARTIES END *********************** */

		/** ***************** DELETE BUSINESS REALETED PARTIES START *********************** */
		case RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_SUCCESS:
			return { ...state, deleteBusinessPartiesResponse: action.payload };

		case RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_FAILURE:
			return { ...state, deleteBusinessPartiesResponse: action.payload };

		case RelatedPartiesActionTypes.DELETE_RELATED_PARTIES_RESPONSE_CHANGED:
			return { ...state, deleteBusinessPartiesResponse: null };
		/** ***************** DELETE BUSINESS REALETED PARTIES END *********************** */

		default:
			return state;
	}
};
// BUSINESS RELATED PARTIES REDUCER -END
export default businessRelatedPartiesReducer;
